import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface StarStoryProps {
  title: string;
  situation: string;
  task: string;
  action: string;
  result: string;
  imageUrl: string;
  imageAlt: string;
  animationComponent?: React.ReactNode;
}
const StarStory: React.FC<StarStoryProps> = ({
  title,
  situation,
  task,
  action,
  result,
  imageUrl,
  imageAlt,
  animationComponent
}) => {
  return <motion.div className="mb-16" initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} data-id="element-73">
      <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-74">{title}</h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-75">
        <div data-id="element-76">
          <div className="mb-4" data-id="element-77">
            <h4 className="font-bold text-gray-800 mb-1" data-id="element-78">Situation</h4>
            <p className="text-gray-700" data-id="element-79">{situation}</p>
          </div>
          <div className="mb-4" data-id="element-80">
            <h4 className="font-bold text-gray-800 mb-1" data-id="element-81">Task</h4>
            <p className="text-gray-700" data-id="element-82">{task}</p>
          </div>
          <div className="mb-4" data-id="element-83">
            <h4 className="font-bold text-gray-800 mb-1" data-id="element-84">Action</h4>
            <p className="text-gray-700" data-id="element-85">{action}</p>
          </div>
          <div data-id="element-86">
            <h4 className="font-bold text-gray-800 mb-1" data-id="element-87">Result</h4>
            <p className="text-gray-700" data-id="element-88">{result}</p>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-89">
          <img src={imageUrl} alt={imageAlt} className="rounded-lg shadow-md mb-4 w-full max-w-md object-cover" data-id="element-90" />
          {animationComponent && <div className="mt-4 w-full" data-id="element-91">{animationComponent}</div>}
        </div>
      </div>
    </motion.div>;
};
export default StarStory;